export default __webpack_public_path__ + "static/media/blog.21552f50.png";